export const courseInternalOptions = [
  { value: 'true', label: 'Interno' },
  { value: 'false', label: 'Externo' },
];

export const countryOptions = [
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Uruguay', label: 'Uruguay' },
];

export const courseOptionsTypeOptions = [
  { value: 'EXPRESS', label: 'Express' },
  { value: 'FULL', label: 'Full' },
];

export const questionOptions = [
  {
    label: 'Seleccione un tipo',
    value: ' ',
  },
  {
    label: 'Dropdown',
    value: 'DROPDOWN',
  },
  {
    label: 'Short answer',
    value: 'SHORT_ANSWER',
  },
  {
    label: 'Paragraph',
    value: 'PARAGRAPH',
  },
  {
    label: 'Checkbox',
    value: 'CHECKBOXES',
  },
  {
    label: 'Multiple choice',
    value: 'MULTIPLE_CHOICES',
  },
];

export const stateOptions = [
  { value: 'PENDING', label: 'Pendiente' },
  { value: 'IN_PROGRESS', label: 'En Progreso' },
  { value: 'COMPLETED', label: 'Completado' },
];

export const typeOptions = [
  { value: 'DEV', label: 'Dev' },
  { value: 'QA', label: 'Qa' },
  { value: 'UX/UI', label: 'UX/UI' },
  { value: 'GENERAL', label: 'General' },
];

export const roleOptions = [
  { value: '', label: 'Ninguno' },
  { value: 'ADMIN', label: 'Administrador' },
  { value: 'TUTOR', label: 'Tutor' },
  { value: 'AUXILIARY', label: 'Auxiliar' },
  { value: 'STUDENT', label: 'Alumno' },
];
